export default "__VITE_ASSET__Bl43L4XI__"